import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import { BlockInfo } from '../../containers/Blocks';

const BlockDetailsModal = ({ blockId, close }) => {
  if (blockId) {
    return (
      <Modal
        className="modal show"
        open={!!blockId}
        onClose={() => close()}
      >

        <div className="modal-content"
          style={{
            width: 400,
            height: 'max-content',
            margin: 'calc(30% - 390px) auto 0',
            overflow: 'auto'
          }}
        >
          <div className="modalContent">
            <BlockInfo
              // title={true}
              blockId={blockId}
            />
            <Button
              onClick={() => close()}
              variant="contained" color="default"
              style={{ margin: 'auto', display: 'block' }}>
              Close
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
  return null;
}

export default BlockDetailsModal;



// WEBPACK FOOTER //
// ./src/components/workouts/BlockDetailsModal.js